/* ==========================================================================
   PAINSHOP · VISORE IMMAGINI
   Apre a schermo intero le immagini dentro agli accordion della scheda
   prodotto (la size chart) e le lascia ingrandire: clic per zoomare sul punto
   toccato, trascinamento per spostarsi, pizzico su telefono, rotella su
   computer, ESC per uscire. Nessuna libreria.
   ========================================================================== */

(function () {
  'use strict';

  var SELECTOR = 'main [class*="accordion"] img, [data-rop-zoom] img';
  var MAX = 5;
  var STEP = 2.6;

  var box = null, stage = null, img = null, hint = null;
  var scale = 1, tx = 0, ty = 0;
  var dragging = false, moved = false, lastX = 0, lastY = 0;
  var pointers = {}, pinchStart = 0, pinchScale = 1;

  function build() {
    if (box) return;

    box = document.createElement('div');
    box.className = 'rop-zoom';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');

    stage = document.createElement('div');
    stage.className = 'rop-zoom__stage';

    img = document.createElement('img');
    img.className = 'rop-zoom__img';
    img.alt = '';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'rop-zoom__close';
    close.textContent = '[ CLOSE ]';
    close.addEventListener('click', hide);

    hint = document.createElement('p');
    hint.className = 'rop-zoom__hint';
    hint.textContent = 'TAP TO ZOOM · DRAG TO MOVE · ESC TO CLOSE';

    stage.appendChild(img);
    box.appendChild(stage);
    box.appendChild(close);
    box.appendChild(hint);
    document.body.appendChild(box);

    // clic sullo sfondo: chiude. Clic sull'immagine: zooma.
    stage.addEventListener('click', function (e) {
      if (moved) { moved = false; return; }
      if (e.target !== img) { hide(); return; }
      toggle(e.clientX, e.clientY);
    });

    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var next = clamp(scale * (e.deltaY < 0 ? 1.18 : 1 / 1.18), 1, MAX);
      setScale(next, e.clientX, e.clientY);
    }, { passive: false });

    stage.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove, { passive: false });
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
  }

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  function apply() {
    img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    box.classList.toggle('is-zoomed', scale > 1.01);
  }

  /* zooma tenendo fermo il punto sotto al dito */
  function setScale(next, cx, cy) {
    var r = img.getBoundingClientRect();
    var ox = (cx === undefined ? r.left + r.width / 2 : cx) - (r.left + r.width / 2);
    var oy = (cy === undefined ? r.top + r.height / 2 : cy) - (r.top + r.height / 2);
    var k = next / scale;
    tx = tx - ox * (k - 1);
    ty = ty - oy * (k - 1);
    scale = next;
    if (scale <= 1.01) { scale = 1; tx = 0; ty = 0; }
    apply();
  }

  function toggle(cx, cy) {
    if (scale > 1.01) { scale = 1; tx = 0; ty = 0; apply(); }
    else setScale(STEP, cx, cy);
  }

  function onDown(e) {
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pointers);
    if (ids.length === 2) {
      pinchStart = dist(pointers[ids[0]], pointers[ids[1]]);
      pinchScale = scale;
      dragging = false;
      return;
    }
    if (scale <= 1.01) return;
    dragging = true;
    moved = false;
    lastX = e.clientX;
    lastY = e.clientY;
    box.classList.add('is-panning');
  }

  function onMove(e) {
    if (!(e.pointerId in pointers)) return;
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };

    var ids = Object.keys(pointers);
    if (ids.length === 2 && pinchStart) {
      e.preventDefault();
      var d = dist(pointers[ids[0]], pointers[ids[1]]);
      var mid = {
        x: (pointers[ids[0]].x + pointers[ids[1]].x) / 2,
        y: (pointers[ids[0]].y + pointers[ids[1]].y) / 2
      };
      setScale(clamp(pinchScale * (d / pinchStart), 1, MAX), mid.x, mid.y);
      moved = true;
      return;
    }

    if (!dragging) return;
    e.preventDefault();
    var dx = e.clientX - lastX;
    var dy = e.clientY - lastY;
    if (Math.abs(dx) > 2 || Math.abs(dy) > 2) moved = true;
    tx += dx;
    ty += dy;
    lastX = e.clientX;
    lastY = e.clientY;
    apply();
  }

  function onUp(e) {
    delete pointers[e.pointerId];
    if (Object.keys(pointers).length < 2) pinchStart = 0;
    dragging = false;
    box && box.classList.remove('is-panning');
  }

  function dist(a, b) {
    var dx = a.x - b.x, dy = a.y - b.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function show(src, alt) {
    build();
    img.src = src;
    img.alt = alt || '';
    scale = 1; tx = 0; ty = 0;
    apply();
    box.classList.add('is-on');
    document.documentElement.classList.add('rop-zoom-locked');
  }

  function hide() {
    if (!box) return;
    box.classList.remove('is-on', 'is-zoomed', 'is-panning');
    document.documentElement.classList.remove('rop-zoom-locked');
    pointers = {};
    dragging = false;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (box && box.contains(e.target)) return;
    var hit = e.target.closest(SELECTOR);
    if (!hit) return;
    e.preventDefault();
    show(hit.currentSrc || hit.src, hit.alt);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && box && box.classList.contains('is-on')) hide();
  });
})();